<template>
  <div class="flex h-full flex-col">
    <AppNavbar />

    <div class="container flex grow justify-center bg-[#fdfdff] pb-10 pt-6 md:pt-10">
      <div class="mx-3 w-full max-w-xl lg:mx-4">
        <AppCard class="!rounded-3xl !p-4 !pb-8 !pt-5 !shadow-auth-card lg:!p-6 lg:!pb-10">
          <slot />
        </AppCard>
      </div>
    </div>

    <AppFooter class="shrink-0" />
  </div>
</template>
